import React from 'react';
import * as MDICONS from '@material-ui/icons';
import * as ROUTES from '../../constants/routes';
import { Link } from 'react-router-dom';

const DashboardLock = (props) => {
    const { isProjectTagLimitReached, isCompanyTagLimitReached, isSubscriptionBoughtActive } = props;
    const projectTagLimitReachedDescription = isProjectTagLimitReached ? "project's" : '';
    const companyTagLimitReachedDescription = isCompanyTagLimitReached ? "company's" : '';
    const subscriptionDescription = "Please apply a subscription to complete your registration process.";
    return (
        <div className="p-5" >
            <MDICONS.Lock scale={0.5} />


            {isSubscriptionBoughtActive ?
                <p className="py-1">You have exceeded your {projectTagLimitReachedDescription} {companyTagLimitReachedDescription} tag limit</p>
                :
                <p className="py-1">{subscriptionDescription}</p>}

            <p><Link to={ROUTES.PRICING} className="mx-2" style={{ color: 'black' }}><b>Check out the plans here!</b></Link></p>

        </div>
    );
};

export default DashboardLock;